import CalendarSelect from '../CalendarSelect';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { FrameworkActionCreator, AppointmentActionCreator, RMTimesActionCreator } from 'src/store/states';
import { BlankDeptSpec } from 'src/models/Specs/TestSpecs';

const mapStateToProps = (state: IStoreState) => {
    const timeOfDay = state.Specs.deptSpecs?.timeOfDay !== undefined ?
        state.Specs.deptSpecs.timeOfDay : [];

    const advisors = state.Specs.deptSpecs?.Advisors !== undefined ?
        state.Specs.deptSpecs.Advisors : [];

    const allowTimes = state.Specs.deptSpecs?.allTimesOption !== undefined ?
        state.Specs.deptSpecs.allTimesOption : false;

    const allowTimesName = state.Specs.deptSpecs?.advisorOption !== undefined ?
        state.Specs.deptSpecs.advisorOption : '';

    const transportations = state.Specs.deptSpecs?.Transportation !== undefined ?
        state.Specs.deptSpecs.Transportation : [];

    const rmTimes = state.RMTimes.rmTimeSlots;

    const shopHours = state.Specs.deptSpecs?.shopHours !== undefined ?
        state.Specs.deptSpecs?.shopHours : [];

    const specProfile = state.Framework.specProfile;
    const apptCust = state.Appointment.ApptCust;
    const rmBuiltFlag = state.RMTimes.rmTimes.BuiltFlag;
    const specDeptData = state.Specs.deptSpecs !== undefined ? state.Specs.deptSpecs : BlankDeptSpec;
    const invalidDates = state.RMTimes.invalidDates !== undefined ? state.RMTimes.invalidDates : [];
    const theme = state.Framework.theme;
    const colorSensitiveEnabled = state.Framework.colorSensitiveEnabled;
    const apptNum = state.Appointment.Appointment.apptNum;
    const checkedRecalls = state.AdditionalServices.checkedRecalls;
    const apptOps = state.Appointment.ApptOps;
    const vehRecalls = state.AdditionalServices.recallData.recalls;
    const vehicles = state.Vehicles.vehicles;
    const mainPaneViewOrder = state.Framework.mainPaneViewOrder;
    const locale = state.Framework.locale;
    const selectedVehicle = state.Vehicles.selectedVehicle ?? '';
    const rmTransEligible = state.RMTimes.rmTransEligible;
    const gmossVersion = state.Framework.gmossVersion ?? '';
    const apptAdvisor = state.Appointment.Appointment.advName;
    const apptAdvisorNum = state.Appointment.Appointment.advisor;
    const apptAdvisorUrl = state.Appointment.Appointment.advImage;
    const viewMode = state.Framework.viewMode;
    const custInfo = state.Customer.Customer;
    const multipleCustomers = state.Customer.multipleCustomers;
    const appointment = state.Appointment;
    const specData = state.Specs.specs;
    const sessionId = state.Framework.sessionId;
    const lexusMCLaunched = state.Framework.lexusMCLaunched;
    const toyotaMCLaunched = state.Framework.toyotaMCLaunched;
    const lexusTDMCLaunched = state.Framework.lexusTDMCLaunched;
    const toyotaTDMCLaunched = state.Framework.toyotaTDMCLaunched;

    return {
        timeOfDay: timeOfDay,
        transportation: transportations,
        advisors: advisors,
        allowTimes: allowTimes,
        allowTimesName: allowTimesName,
        rmTimes: rmTimes,
        shopHours: shopHours,
        specProfile: specProfile,
        apptCust: apptCust,
        rmBuiltFlag: rmBuiltFlag,
        specDeptData: specDeptData,
        invalidDates: invalidDates,
        theme: theme,
        colorSensitiveEnabled: colorSensitiveEnabled,
        apptNum: apptNum,
        checkedRecalls: checkedRecalls,
        apptOps: apptOps,
        vehRecalls: vehRecalls,
        vehicles: vehicles,
        mainPaneViewOrder: mainPaneViewOrder,
        locale: locale,
        selectedVehicle: selectedVehicle,
        rmTransEligible: rmTransEligible,
        gmossVersion: gmossVersion,
        apptAdvisor: apptAdvisor,
        apptAdvisorNum: apptAdvisorNum,
        apptAdvisorUrl: apptAdvisorUrl,
        viewMode: viewMode,
        custInfo: custInfo,
        multipleCustomers: multipleCustomers!,
        appointment: appointment,
        specData: specData,
        sessionId: sessionId,
        lexusMCLaunched: lexusMCLaunched,
        toyotaMCLaunched: toyotaMCLaunched,
        lexusTDMCLaunched: lexusTDMCLaunched,
        toyotaTDMCLaunched: toyotaTDMCLaunched,
    };
};

const mapDispatchToProps = {
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    updateApptDate: AppointmentActionCreator.UpdateApptDate,
    updateApptCust: AppointmentActionCreator.UpdateApptCust,
    getRMTimes: RMTimesActionCreator.GetRMTimes,
    clearRMTimes: RMTimesActionCreator.ClearRMTimes,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    getInvalidDates: RMTimesActionCreator.GetInvalidDates,
    clearInvalidDates: RMTimesActionCreator.ClearInvalidDates,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CalendarSelect);